/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Activity update request
 * @export
 * @interface UpdateActivityRequest
 */
export interface UpdateActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateActivityRequest
     */
    sessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateActivityRequest
     */
    activityType?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateActivityRequest
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the UpdateActivityRequest interface.
 */
export function instanceOfUpdateActivityRequest(value: object): value is UpdateActivityRequest {
    return true;
}

export function UpdateActivityRequestFromJSON(json: any): UpdateActivityRequest {
    return UpdateActivityRequestFromJSONTyped(json, false);
}

export function UpdateActivityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateActivityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['session_id'] == null ? undefined : json['session_id'],
        'activityType': json['activity_type'] == null ? undefined : json['activity_type'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function UpdateActivityRequestToJSON(json: any): UpdateActivityRequest {
    return UpdateActivityRequestToJSONTyped(json, false);
}

export function UpdateActivityRequestToJSONTyped(value?: UpdateActivityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'session_id': value['sessionId'],
        'activity_type': value['activityType'],
        'metadata': value['metadata'],
    };
}

